module.exports = __webpack_public_path__ + "img/logo.916f5cbc.png";